/**
 * @file Disco-daily login entry point.
 * @copyright Copyright (c) 2025-2026 Woolly Bear Software LLC,
 *            all rights reserved.
 */
import React from "react";
import { createRoot } from "react-dom/client";
import { AppThemeProvider } from "./AppThemeProvider";
import { Login } from "./views/login";

try {
  const container = document.getElementById("root");
  if (!container) {
    throw new Error("Missing #root element for login entry point.");
  }
  const root = createRoot(container);
  root.render(
    <AppThemeProvider>
      <Login />
    </AppThemeProvider>,
  );
} catch (e) {
  console.error("Unhandled exception at login root: ", e);
}
